import React, {useEffect, useState} from "react";
import NotificationItem from "../../Items/NotificationItem";
import Icon from "@mui/material/Icon";
import MDButton from "../../../components/MDButton";
import {applyCartDiscountCodeItem, getCompanyDiscountCodes} from "../api/WebApi";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Menu from "@mui/material/Menu";

export default function CartDiscounts({cart, client, getCartFullFn}) {

  const [discountCodes, setDiscountCodes] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [discountCodesOpen, setDiscountCodesOpen] = useState(false);
  const [showItemDiscount, setShowItemDiscount] = useState(false);
  const [discountItem, setDiscountItem] = useState();
  const [itemRender, setItemRender] = useState(1);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option) => {
    option.action();
    handleClose();
  };


  useEffect(() => {
    getDiscountCodes();
  }, []);

  const [error, setError] = useState(null);

  const getDiscountCodes = () => {
    getCompanyDiscountCodes().then(result => {
      if (result.error) {
      } else {
        setDiscountCodes(result.filter((rr) => !!!rr.multiple));
      }
    });
  }

  const applyDiscountCode = (discountCode) => {
    applyCartDiscountCodeItem(client?.guid, discountCode).then((resp) => {
      setShowItemDiscount(false);
      setItemRender(itemRender + 1);
      getCartFullFn();
    }).catch((err) => {
      setError(err?.response?.data);
    })
  }

  const DiscountCodeItemActions = () => {
    return (<PopupState variant="popover" popupId={'discount-codes-popup-menu'}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton color="primary"
                     style={{
                       height: '32px'
                     }}
                     variant={'outlined'} size={'small'}
           >
                     Add Discount Code&nbsp;<Icon>expand_more</Icon>
                  </MDButton>
          </span>
          {error && <p>{error?.message}</p>}

          <Menu {...bindMenu(popupState)}>
            {discountCodes?.map((discount, idx) => {
              return (<NotificationItem key={idx}
                                        onClick={(e) => {
                                          popupState.close();
                                          // manageNoteFn(item)
                                          applyDiscountCode(discount);
                                        }} icon={<Icon>add_box</Icon>} title={discount.name}/>)
            })}
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (<>
    {discountCodes?.length > 0 && <>
      <DiscountCodeItemActions/>
    </>
    }
  </>)
}
